/**
 * Card Image Size Enum
 */
export var CardImageSize;
(function (CardImageSize) {
    CardImageSize[CardImageSize["SIZE_1"] = 1] = "SIZE_1";
    CardImageSize[CardImageSize["SIZE_2"] = 2] = "SIZE_2";
    CardImageSize[CardImageSize["SIZE_3"] = 3] = "SIZE_3";
    CardImageSize[CardImageSize["SIZE_4"] = 4] = "SIZE_4";
})(CardImageSize || (CardImageSize = {}));
//# sourceMappingURL=CardImageEnum.js.map